import React, { FC, memo, useMemo } from 'react'
import { FluidImage, HStack } from '../index'
import { Center, Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { cardImageMap } from '../../state/interfaces'

export interface PhoneAllCardProps {
  phones: string
  onClick: (phones: string) => void
  phonesToShow: number
}

export const PhoneAllCard: FC<PhoneAllCardProps> = memo(({ phones, onClick, phonesToShow }) => {
  const { t } = useTranslation()
  const image = useMemo(() => cardImageMap['all-phones'], [])

  return (
    <HStack
      role="button"
      aria-label="phone-all-card"
      width="full"
      maxWidth={290}
      maxHeight={120}
      borderRadius="default"
      justifyContent="space-between"
      padding={4}
      marginBottom={4}
      border={2}
      borderStyle="solid"
      borderColor="grey"
      userSelect="none"
      cursor="pointer"
      marginX={1}
      _hover={{
        borderColor: 'brand',
      }}
      label="phone-all-card"
      onClick={() => onClick(phones)}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          onClick(phones)
        }
      }}
      position="relative"
      _focus={{
        borderColor: 'brand',
        boxShadow: '0 0 0 3px #5bce4c',
      }}
      tabIndex={0}
    >
      <Flex alignItems="center" width="full" height="100%">
        <FluidImage src={image} alt="all-phones" />
        <Center
          width={20}
          height={20}
          flex={1}
          fontWeight="bold"
          fontSize={16}
          textAlign={'center'}
          textDecor={'underline'}
        >
          {
            t('search-all-phones', {
              deviceCount: phonesToShow,
            }) as string
          }
        </Center>
      </Flex>
    </HStack>
  )
})
